export const placeholderImageSrc = '/placeholder-image.png';
export const placeholderImageSrcSet = `/placeholder-image.png, /placeholder-image2x.png`;
